var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"message-fade"}},[(_vm.visible)?_c('div',{class:_vm.wrapClasses},[_c('img',{staticClass:"message_img",attrs:{"src":_vm.typeImg}}),_c('span',{},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ccaa30c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/messgae/message.vue
// module id = null
// module chunks = 